function pluralApartments(count) {
  const n = Number(count) || 0;
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return `${n} квартира`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `${n} квартиры`;
  return `${n} квартир`;
}

function formatMln(price) {
  const value = Math.round((Number(price) / 1000000) * 10) / 10;
  return String(value).replace(/\.0$/, '');
}

function formatPriceLabel(min, max) {
  return `${formatMln(min)}-${formatMln(max)} млн ₽`;
}

function formatFloorLabel(min, max) {
  return min === max ? `${min} этаж` : `${min}–${max} этаж`;
}

function formatSquareLabel(min, max) {
  const fmt = (v) => {
    const n = Number(v);
    return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.?0+$/, '');
  };
  return `${fmt(min)}–${fmt(max)} м²`;
}

function parseBuildings(input) {
  try {
    return JSON.parse(input.getAttribute('data-buildings') || '[]');
  } catch (e) {
    return [];
  }
}

function initHomeFilter(root) {
  const form = root.querySelector('[data-home-filter-form]') || root.querySelector('form');
  const fields = Array.from(root.querySelectorAll('.home-filter__field'));
  const defaults = {
    minFloor: root.dataset.minFloor,
    maxFloor: root.dataset.maxFloor,
    minPrice: root.dataset.minPrice,
    maxPrice: root.dataset.maxPrice,
    minSquare: root.dataset.minSquare,
    maxSquare: root.dataset.maxSquare,
    priceLabel: root.dataset.priceLabel,
  };

  function closeAll(except) {
    fields.forEach((field) => {
      if (field === except) return;
      const btn = field.querySelector('.home-filter__select');
      const dropdown = field.querySelector('.home-filter__dropdown');
      if (!btn || !dropdown) return;
      btn.setAttribute('aria-expanded', 'false');
      field.classList.remove('is-open');
      dropdown.hidden = true;
    });
  }

  function setLabel(field, text) {
    const label = field.querySelector('.home-filter__select-label');
    if (label) label.textContent = text;
  }

  function placeholderOf(field) {
    const label = field.querySelector('.home-filter__select-label');
    return label?.dataset.placeholder || '';
  }

  function renderBuildings(field, projectInput) {
    const slug = projectInput?.value;
    field.querySelectorAll('[data-buildings-for]').forEach((box) => {
      box.hidden = true;
      box.innerHTML = '';
    });
    if (!projectInput || !slug) return;

    const box = field.querySelector(`[data-buildings-for="${slug}"]`);
    if (!box) return;
    const buildings = parseBuildings(projectInput);
    if (!buildings.length) return;

    const currentBuilding = field.querySelector('[data-home-building]')?.value || '';
    const chips = [{ id: '', slug: '', name: 'Все' }, ...buildings];
    box.innerHTML = chips.map((building) => {
      const checked = (building.slug || '') === currentBuilding || (!currentBuilding && !building.slug);
      return `
      <label class="home-filter__building-chip">
        <input type="radio" name="ui_home_building" value="${building.slug || ''}" data-label="${building.name}" ${checked ? 'checked' : ''}>
        <span>${building.name}</span>
      </label>`;
    }).join('');
    box.hidden = false;
  }

  function updateProjectCount(field) {
    const countEl = field.querySelector('[data-project-count]');
    const selected = field.querySelector('input[name="ui_home_project"]:checked');
    if (!countEl) return;
    countEl.textContent = selected ? pluralApartments(Number(selected.dataset.count || 0)) : '';
  }

  function applyProject(field) {
    const selected = field.querySelector('input[name="ui_home_project"]:checked');
    const building = field.querySelector('input[name="ui_home_building"]:checked');
    const projectInput = field.querySelector('[data-home-value]');
    const buildingInput = field.querySelector('[data-home-building]');
    if (!selected) {
      projectInput.value = '';
      buildingInput.value = '';
      setLabel(field, placeholderOf(field));
      return;
    }
    projectInput.value = selected.value;
    buildingInput.value = building?.value || '';
    let label = selected.dataset.label || selected.value;
    if (building?.value) label = `${label}, ${building.dataset.label || building.value}`;
    setLabel(field, label);
  }

  function applyRoom(field) {
    const selected = field.querySelector('input[name="ui_home_room"]:checked');
    const valueInput = field.querySelector('[data-home-value]');
    if (!selected) {
      valueInput.value = '';
      setLabel(field, placeholderOf(field));
      return;
    }
    valueInput.value = selected.value;
    setLabel(field, selected.dataset.label || selected.value);
  }

  function rangeBounds(minInput, maxInput) {
    const absMin = Number(minInput.dataset.absMin ?? minInput.min);
    const absMax = Number(maxInput.dataset.absMax ?? maxInput.max);
    return {
      absMin: Number.isFinite(absMin) ? absMin : 0,
      absMax: Number.isFinite(absMax) ? absMax : 0,
    };
  }

  function sanitizeRangeTyping(input) {
    const allowDecimal = (input.getAttribute('inputmode') || '') === 'decimal';
    let next = String(input.value ?? '').replace(/[^\d.,]/g, '').replace(',', '.');
    if (allowDecimal) {
      const parts = next.split('.');
      next = parts.shift() + (parts.length ? `.${parts.join('').replace(/\./g, '')}` : '');
    } else {
      next = next.replace(/\./g, '');
    }
    if (input.value !== next) input.value = next;
  }

  function parseRangeDraft(minInput, maxInput) {
    const { absMin, absMax } = rangeBounds(minInput, maxInput);
    const minRaw = String(minInput.value ?? '').trim().replace(',', '.');
    const maxRaw = String(maxInput.value ?? '').trim().replace(',', '.');
    let min = minRaw === '' ? NaN : Number(minRaw);
    let max = maxRaw === '' ? NaN : Number(maxRaw);
    if (Number.isNaN(min)) min = absMin;
    if (Number.isNaN(max)) max = absMax;
    if (min > max) [min, max] = [max, min];
    min = Math.max(absMin, Math.min(absMax, min));
    max = Math.max(absMin, Math.min(absMax, max));
    return { min, max, absMin, absMax };
  }

  function applyRange(field, { force = false } = {}) {
    const minInput = field.querySelector('[data-range-min]');
    const maxInput = field.querySelector('[data-range-max]');
    const hiddenMin = field.querySelector('[data-home-min]');
    const hiddenMax = field.querySelector('[data-home-max]');
    const format = field.dataset.format;
    const name = field.dataset.field;
    if (!minInput || !maxInput || !hiddenMin || !hiddenMax) return;

    const active = document.activeElement;
    if (!force && (active === minInput || active === maxInput)) return;

    const { min, max, absMin, absMax } = parseRangeDraft(minInput, maxInput);
    minInput.value = String(min);
    maxInput.value = String(max);

    const isDefault = min === absMin && max === absMax;
    if (isDefault) {
      hiddenMin.value = '';
      hiddenMax.value = '';
      setLabel(field, name === 'price' ? defaults.priceLabel : placeholderOf(field));
      return;
    }

    hiddenMin.value = String(min);
    hiddenMax.value = String(max);
    if (format === 'price') setLabel(field, formatPriceLabel(min, max));
    else if (format === 'square') setLabel(field, formatSquareLabel(min, max));
    else setLabel(field, formatFloorLabel(min, max));
  }

  function commitField(field) {
    const type = field.dataset.field;
    if (type === 'project') applyProject(field);
    else if (type === 'room') applyRoom(field);
    else if (field.hasAttribute('data-range')) applyRange(field, { force: true });
  }

  function commitAll() {
    fields.forEach((field) => commitField(field));
    root.querySelectorAll('input[name^="ui_"]').forEach((el) => {
      el.disabled = true;
    });
    form?.querySelectorAll('input[type="hidden"][name]').forEach((el) => {
      if (!el.value) el.disabled = true;
    });
  }

  function applyField(field) {
    commitField(field);
    closeAll();
  }

  function resetField(field, close = true) {
    const type = field.dataset.field;
    field.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.checked = false;
    });

    if (type === 'project') {
      field.querySelectorAll('[data-buildings-for]').forEach((box) => {
        box.hidden = true;
        box.innerHTML = '';
      });
      const countEl = field.querySelector('[data-project-count]');
      if (countEl) countEl.textContent = '';
      field.querySelector('[data-home-value]').value = '';
      field.querySelector('[data-home-building]').value = '';
      setLabel(field, placeholderOf(field));
    } else if (type === 'room') {
      field.querySelector('[data-home-value]').value = '';
      setLabel(field, placeholderOf(field));
    } else if (field.hasAttribute('data-range')) {
      const minInput = field.querySelector('[data-range-min]');
      const maxInput = field.querySelector('[data-range-max]');
      const map = {
        floor: ['minFloor', 'maxFloor'],
        price: ['minPrice', 'maxPrice'],
        square: ['minSquare', 'maxSquare'],
      };
      const [minKey, maxKey] = map[type] || [];
      minInput.value = defaults[minKey];
      maxInput.value = defaults[maxKey];
      field.querySelector('[data-home-min]').value = '';
      field.querySelector('[data-home-max]').value = '';
      setLabel(field, type === 'price' ? defaults.priceLabel : placeholderOf(field));
    }

    if (close) closeAll();
  }

  fields.forEach((field) => {
    const btn = field.querySelector('.home-filter__select');
    const dropdown = field.querySelector('.home-filter__dropdown');
    if (!btn || !dropdown) return;

    btn.addEventListener('click', (event) => {
      event.preventDefault();
      const isOpen = field.classList.contains('is-open');
      fields.forEach((other) => {
        if (other !== field && other.classList.contains('is-open')) commitField(other);
      });
      closeAll();
      if (isOpen) {
        commitField(field);
        return;
      }
      field.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      dropdown.hidden = false;
    });

    dropdown.addEventListener('click', (event) => {
      const actionBtn = event.target.closest('[data-action]');
      if (!actionBtn) return;
      event.preventDefault();
      if (actionBtn.dataset.action === 'apply-field') applyField(field);
      if (actionBtn.dataset.action === 'reset-field') resetField(field);
    });

    dropdown.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (field.dataset.field === 'project') {
        if (input.name === 'ui_home_project') {
          renderBuildings(field, input);
          updateProjectCount(field);
        }
        applyProject(field);
        return;
      }
      if (field.dataset.field === 'room' && input.name === 'ui_home_room') {
        applyRoom(field);
      }
    });

    if (field.hasAttribute('data-range')) {
      dropdown.querySelectorAll('[data-range-min], [data-range-max]').forEach((input) => {
        input.addEventListener('input', () => {
          sanitizeRangeTyping(input);
        });
        input.addEventListener('blur', () => {
          applyRange(field, { force: true });
        });
        input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          applyRange(field, { force: true });
          applyField(field);
        });
      });
    }
  });

  root.querySelector('[data-home-clear]')?.addEventListener('click', (event) => {
    event.preventDefault();
    fields.forEach((field) => resetField(field, false));
    closeAll();
  });

  document.addEventListener('click', (event) => {
    if (root.contains(event.target)) return;
    const openFields = fields.filter((field) => field.classList.contains('is-open'));
    if (!openFields.length) return;
    openFields.forEach((field) => commitField(field));
    closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    fields.filter((field) => field.classList.contains('is-open')).forEach((field) => commitField(field));
    closeAll();
  });

  if (form) {
    form.addEventListener('submit', () => {
      commitAll();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-home-filter]').forEach(initHomeFilter);
});
